module.exports = __webpack_public_path__ + "static/img/HK-and-MO-pass-front.dd76d18e.png";